import React, {useMemo} from 'react'
import {createSelectItem} from "components/Select";
import GridBlock from "components/GridBlock";
import {makeStyles} from "@material-ui/styles";
import IconButton from "components/button/IconButton";
import ArrowIconLeft from "@material-ui/icons/KeyboardArrowLeft";
import ArrowIconRight from "@material-ui/icons/KeyboardArrowRight";
import {Paper} from "@material-ui/core";
import Tr from "translations/Translations"
import WorkableButton from "components/button/WorkableButton";
import {annualReportStepsOrder} from "../../constants/annualReportSteps";
import SimpleSelect from "components/SimpleSelect";
import EZamowieniaIcon from "components/icon/EZamowieniaIcon";
import {simpleConfirm} from "../../../../../../libs/ConfirmNotification";

const useStyle = makeStyles(theme => ({
    root: {
        position: 'sticky',
        zIndex: theme.zIndex.appBar - 1,
        top: 67,
        marginBottom: theme.spacing(2),
    },
    paper: {
        padding: theme.spacing(0.5),
        border: `solid 2px ${theme.palette.border.dark}`,
    },
    select: {
        minWidth: 550,
        "&> .MuiInput-root .MuiSelect-root": {
            maxWidth: 550
        }
    },
    margin: {
        margin: `0 ${theme.spacing()}px`
    }
}))

function AnnualReportNavigator(
    {
        formTr,
        disabled,
        buttonWorks,
        curStep,
        onCurStepChange,
        onSendToEzamowienia,
        onSubmitInEzamowienia,
    }) {
    const classes = useStyle();
    const memoItems = useMemo(() => annualReportStepsOrder.map((x, i, arr) => createSelectItem(x, `${formTr(`mmia.${x}`)} (${i + 1}/${arr.length})`)), [formTr])
    const curIndex = annualReportStepsOrder.indexOf(curStep);


    return (<div className={classes.root}>
        <Paper className={classes.paper}>
            <GridBlock justify="space-between" alignItems="center" flexGrow>
                <GridBlock justify="center" alignItems="center">
                    <IconButton
                        className={classes.margin}
                        disabled={buttonWorks.anyWorks || curIndex < 1}
                        tooltip={curIndex > 0 ? formTr(`mmia.${annualReportStepsOrder[curIndex - 1]}`) : undefined}
                        variant="outlined"
                        onClick={() => onCurStepChange(annualReportStepsOrder[curIndex - 1])}
                        Icon={ArrowIconLeft}/>
                    <SimpleSelect disabled={buttonWorks.anyWorks} onChange={(e) => onCurStepChange(e.target.value)} className={classes.select} items={memoItems}
                                  value={curStep}/>
                    <IconButton
                        className={classes.margin}
                        disabled={buttonWorks.anyWorks || curIndex === annualReportStepsOrder.length - 1}
                        tooltip={curIndex < annualReportStepsOrder.length - 1 ? formTr(`mmia.${annualReportStepsOrder[curIndex + 1]}`) : undefined}
                        variant="outlined"
                        onClick={() => onCurStepChange(annualReportStepsOrder[curIndex + 1])}
                        Icon={ArrowIconRight}/>
                </GridBlock>
                <GridBlock justify="flex-end" alignItems="center">
                    {!!onSendToEzamowienia &&
                        <WorkableButton
                            Icon={EZamowieniaIcon}
                            working={buttonWorks.ezamowienia}
                            disabled={disabled || buttonWorks.anyWorks}
                            variant="outlined"
                            onClick={onSendToEzamowienia}>{Tr('annual_report_send_to_ezamowienia')}
                        </WorkableButton>}
                    {!!onSubmitInEzamowienia &&
                        <WorkableButton
                            Icon={EZamowieniaIcon}
                            working={buttonWorks.ezamowienia}
                            disabled={disabled || buttonWorks.anyWorks}
                            onClick={() => simpleConfirm("annual_report_submit_to_ezamowienia_confirm", onSubmitInEzamowienia)}>{Tr('annual_report_submit_to_ezamowienia')}
                        </WorkableButton>}
                </GridBlock>
            </GridBlock>
        </Paper>
    </div>)
}

AnnualReportNavigator.propTypes = {};

export default AnnualReportNavigator;
